<template>
  <div class="mt-4" data-userflow-id="products-offers-carrousel">
    <Splide v-if="isEmpty" key="empty-state-splide" :options="options">
      <SplideSlide>
        <product-offers-table key="empty-best" variant="best" :products="bestProductsOnOffers" :is-empty="isEmpty" />
      </SplideSlide>
      <SplideSlide>
        <product-offers-table key="empty-worst" variant="worst" :products="worstProductsOnOffers" :is-empty="isEmpty" />
      </SplideSlide>
      <SplideSlide>
        <product-offers-table key="empty-out" variant="out" :products="bestProductsOutOffers" :is-empty="isEmpty" />
      </SplideSlide>
    </Splide>
    <Splide v-else key="products-splide" :options="options">
      <SplideSlide>
        <product-offers-table key="best" variant="best" :products="bestProductsOnOffers" />
      </SplideSlide>
      <SplideSlide>
        <product-offers-table key="worst" variant="worst" :products="worstProductsOnOffers" />
      </SplideSlide>
      <SplideSlide>
        <product-offers-table key="out" variant="out" :products="bestProductsOutOffers" />
      </SplideSlide>
    </Splide>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import ProductOffersTable from './ProductOffersTable.vue'
import '@splidejs/splide/dist/css/splide.min.css'
export default {
  name: 'ProductsOffersCarrousel',
  components: { ProductOffersTable, Splide, SplideSlide },
  data: () => ({
    options: {
      type: 'loop',
      padding: '9rem',
      gap: '0px',
      speed: 300,
      pagination: false,
      autoplay: true,
      interval: 8000,
      updateOnMove: true,
    },
  }),
  computed: {
    ...mapGetters(['dreProductsMetrics']),
    bestProductsOnOffers() {
      return this.isEmpty ? [] : this.dreProductsMetrics.bestProductsOnOffers
    },
    worstProductsOnOffers() {
      return this.isEmpty ? [] : this.dreProductsMetrics.worstProductsOnOffers
    },
    bestProductsOutOffers() {
      return this.isEmpty ? [] : this.dreProductsMetrics.bestProductsOutOffers
    },
    isEmpty() {
      for (var prop in this.dreProductsMetrics) {
        if (this.dreProductsMetrics.hasOwnProperty(prop)) return false
      }

      return true
    },
  },
}
</script>

<style lang="scss" scoped>
li:not(.is-active) {
  .card-shadow {
    transform: scale(0.9);
    filter: blur(1.5px);
  }
}

li {
  padding-bottom: 4px;
}

::v-deep .splide__arrow--prev {
  left: 7rem;
}

::v-deep .splide__arrow--next {
  right: 7rem;
}

::v-deep .splide__arrow {
  background: $branco;
  color: $cinza-d20;
  width: 26px;
  height: 26px;

  svg {
    width: 12px;
    height: 12px;
  }
}
</style>
